import React from 'react';
import styles from './index.module.less';
import PropTypes from 'prop-types';
import {getFileUrl} from '@/page/util/appUrlUtils';

// 导入现有图片资源
import fileIcon from '@/asset/file.png';
import audioPlayerIcon from '@/asset/Audio-Player.png';
import videoPlayerIcon from '@/asset/Video-Player.png';

// 导入文件类型专用图标
import wordIcon from '@/asset/filetype/word.svg';
import excelIcon from '@/asset/filetype/excel.svg';
import pptIcon from '@/asset/filetype/ppt.svg';
import pdfIcon from '@/asset/filetype/pdf.svg';
import txtIcon from '@/asset/filetype/txt.svg';

export default function FileCard({title, url, isFile = true, docShare = []}) {
    // 根据文件扩展名获取对应图标
    const getIconByExtension = (extension) => {
        if (!extension) return fileIcon;

        const ext = extension.toLowerCase().replace('.', '');

        // Word文档
        if (['doc', 'docx'].includes(ext)) {
            return wordIcon;
        }
        // Excel表格
        if (['xls', 'xlsx'].includes(ext)) {
            return excelIcon;
        }
        // PowerPoint演示文稿
        if (['ppt', 'pptx'].includes(ext)) {
            return pptIcon;
        }
        // PDF文档
        if (ext === 'pdf') {
            return pdfIcon;
        }
        // 文本文件
        if (['txt', 'text'].includes(ext)) {
            return txtIcon;
        }
        // 音频文件
        if (['mp3', 'wav', 'wma', 'flac', 'aac', 'ogg'].includes(ext)) {
            return audioPlayerIcon;
        }
        // 视频文件
        if (['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'm4v', 'webm'].includes(ext)) {
            return videoPlayerIcon;
        }

        // 其他文件类型使用通用文件图标
        return fileIcon;
    };

    // 从title中提取扩展名
    const getFileExtensionFromTitle = (fileName) => {
        if (!fileName) return '';
        const match = fileName.match(/\.([^.]+)$/);
        return match ? match[1] : '';
    };

    // 根据title的扩展名获取图标
    const icon = getIconByExtension(getFileExtensionFromTitle(title));

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div>
                    <a href={url} className={styles.title} target="_blank">
                        {title}
                    </a>
                </div>
                <div className={styles.icon}>
                    <img
                        src={icon}
                        alt={getFileExtensionFromTitle(title) || 'file'}
                        className={styles.iconImg}
                    />
                </div>
            </div>
            {!isFile &&
                docShare.length > 0 &&
                docShare.map((item, i) => (
                    <div className={styles.file} key={i}>
                        <div className={styles.fileIconContainer}>
                            <img
                                src={getIconByExtension(item.voipDocShare.filename)}
                                alt="file icon"
                                className={styles.fileIcon}
                            />
                        </div>
                        <a
                            href={getFileUrl(
                                item.voipDocShare.attachment,
                                item.voipDocShare.attachmentext
                            )}
                            target="_blank"
                        >
                            {item.voipDocShare.filename}
                        </a>
                    </div>
                ))}
        </div>
    );
}

FileCard.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    isFile: PropTypes.bool,
    docShare: PropTypes.array,
};
